import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  OVERVIEW_DATA_REQUEST,
  SETTLEMENT_PAYMENT_DATA_REQUEST,
  SETTLEMENT_TINFILTER_DATA_REQUEST,
  SETTLEMENT_TREND_COMMERCIAL_REQUEST,
  SETTLEMENT_TREND_DATA_REQUEST,
  SETTLEMENT_TREND_MEDICAID_REQUEST,
  SETTLEMENT_TREND_MEDICARE_REQUEST,
  SETTLEMENT_TREND_UNCATERGORIZED_REQUEST,
  SETTLEMENT_VOLUME_DATA_REQUEST,
  SETTLEMENT_DETAILS_DATA_REQUEST,
  SETTLEMENT_GEOFILTER_DATA_REQUEST,
  SETTLEMENT_RESET_STATE,
  SETTLEMENT_RESET_DATA
} from "@src/middleware/actions/actionTypes";
import {
  commercialDataLoading,
  fetchCommercialData,
  fetchMedicaidData,
  fetchMedicareData,
  fetchOverviewDataSuccess,
  fetchOverviewError,
  fetchSettlementPaymentData,
  fetchtTrendDataSuccess,
  fetchUncategorizedData,
  medicaidDataLoading,
  medicareDataLoading,
  overviewDataLoading,
  paymentDataActionLoading,
  paymentVolumeActionLoading,
  quickFilterTinDataLoading,
  setSettlementDetailsSuccess,
  setSettlementVolumeDataSuccess,
  settlementDetailsLoading,
  settlementTinFilterDataSuccessAction,
  taxIdDataStoreAction,
  trendDataLoading,
  uncategorizedDataLoading,
  geoFilterDataSuccessAction,
} from "@src/middleware/actions/Reimbursement/settlementActions";
import { getQuickFilterTinData } from "@src/middleware/services/reimbusement/settlements/settlement.service";
import {
  getSettlementOVerviewData,
  getSettlementPaymentData,
  getSettlementTrendData,
  getSettlementVolumeData,
  getSettlementDetailsFetchData
} from "@src/apps/Reimbursement/Settlement/Settlement.service";
import { checkMultiTin, checkSingleTin } from "@src/utility/createStorage";


export function* fetchOverviewCardData(action: any) {
  try {
    yield put(overviewDataLoading(true));
    const initialResponse = yield all([
      call(getSettlementOVerviewData, action?.payload)
    ]);

    if (initialResponse) {
      yield put(fetchOverviewDataSuccess(
        initialResponse[0]?.Data
      ));
    }


  } catch (error) {
    // yield put(fetchOverviewError(error));
    yield put(overviewDataLoading(false));
  } finally {
    yield put(overviewDataLoading(false));
  }
}

export function* fetchQuickFilterTinData(action: any) {
  try {
    const response = yield call(getQuickFilterTinData, action?.payload);
    yield put(settlementTinFilterDataSuccessAction(response?.Data ?? []));
    if (checkSingleTin() || checkMultiTin()) {
      const tinData = response?.Data ?? [];
      const tins = tinData.map((item) => item.Tin);
      yield put(taxIdDataStoreAction(tins));
    }
    yield put(quickFilterTinDataLoading(false));
  } catch (error) {
    yield put(quickFilterTinDataLoading(false));
  }
}

export function* fetchSettlementPayment(action: any) {
  try {
    yield put(paymentDataActionLoading(true));
    const initialResponse = yield all([
      call(getSettlementPaymentData, action?.payload)
    ]);

    if (initialResponse) {
      yield put(fetchSettlementPaymentData(
        initialResponse[0]?.Data
      ));
    }

  } catch (error) {
    // yield put(fetchOverviewError(error));
    yield put(paymentDataActionLoading(false));
  } finally {
    yield put(paymentDataActionLoading(false));
  }
}

export function* fetchSettlementVolumeData(action: any) {
  try {
    yield put(paymentVolumeActionLoading(true));
    const initialResponse = yield all([
      call(getSettlementVolumeData, action?.payload)
    ]);

    if (initialResponse) {
      yield put(setSettlementVolumeDataSuccess(
        initialResponse[0]?.Data
      ));
    }

  } catch (error) {
    // yield put(fetchOverviewError(error));
    yield put(paymentVolumeActionLoading(false));
  } finally {
    yield put(paymentVolumeActionLoading(false));
  }
}
export function* fetchSettlementDetailsData(action: any) {
  try {
    yield put(settlementDetailsLoading(true));
    const initialResponse = yield all([
      call(getSettlementDetailsFetchData, action?.payload),
      call(getSettlementDetailsFetchData, action?.payload, "open"),
      call(getSettlementDetailsFetchData, action?.payload, "closed")
    ]);

    if (initialResponse) {
      const collectedData = {
        total: initialResponse[0]?.Data,
        open: initialResponse[1]?.Data,
        closed: initialResponse[2]?.Data,
        startDate: initialResponse[0]?.Data?.StartDate || "",
        endDate: initialResponse[0]?.Data?.EndDate || ""
      }
      yield put(setSettlementDetailsSuccess(collectedData));
    }
  } catch (error) {
    yield put(settlementDetailsLoading(false));
  } finally {
    yield put(settlementDetailsLoading(false));
  }
}
export function* fetchSettlementTrendData(action: any) {
  try {
    yield put(trendDataLoading(true));
    const initialResponse = yield all([
      call(getSettlementTrendData, action?.payload)
    ]);

    if (initialResponse) {
      yield put(fetchtTrendDataSuccess(
        initialResponse[0]
      ));
    }

  } catch (error) {
    // yield put(fetchOverviewError(error));
    yield put(trendDataLoading(false));
  } finally {
    yield put(trendDataLoading(false));
  }
}

export function* fetchSettlementMedicaidData(action: any) {
  try {
    yield put(medicaidDataLoading(true));
    const initialResponse = yield all([
      call(getSettlementTrendData, action?.payload)
    ]);

    if (initialResponse) {
      yield put(fetchMedicaidData(
        initialResponse[0]
      ));
    }


  } catch (error) {
    // yield put(fetchOverviewError(error));
    yield put(medicaidDataLoading(false));
  } finally {
    yield put(medicaidDataLoading(false));
  }
}

export function* fetchSettlementMedicareData(action: any) {
  try {
    yield put(medicareDataLoading(true));
    const initialResponse = yield all([
      call(getSettlementTrendData, action?.payload)
    ]);

    if (initialResponse) {
      yield put(fetchMedicareData(
        initialResponse[0]
      ));
    }

  } catch (error) {
    // yield put(fetchOverviewError(error));
    yield put(medicareDataLoading(false));
  } finally {
    yield put(medicareDataLoading(false));
  }
}

export function* fetchSettlementCommericalData(action: any) {
  try {
    yield put(commercialDataLoading(true));
    const initialResponse = yield all([
      call(getSettlementTrendData, action?.payload)
    ]);

    if (initialResponse) {
      yield put(fetchCommercialData(
        initialResponse[0]
      ));
    }

  } catch (error) {
    // yield put(fetchOverviewError(error));
    yield put(commercialDataLoading(false));
  } finally {
    yield put(commercialDataLoading(false));
  }
}

export function* fetchSettlementUncategorizedData(action: any) {
  try {
    yield put(uncategorizedDataLoading(true));
    const initialResponse = yield all([
      call(getSettlementTrendData, action?.payload)
    ]);

    if (initialResponse) {
      yield put(fetchUncategorizedData(
        initialResponse[0]
      ));
    }

  } catch (error) {
    // yield put(fetchOverviewError(error));
    yield put(uncategorizedDataLoading(false));
  } finally {
    yield put(uncategorizedDataLoading(false));
  }
}

export function* fetchGeoFilterData(action: any) {
  try {
    const response = yield call(getQuickFilterTinData, action?.payload);
    yield put(geoFilterDataSuccessAction(response?.Data ?? []));
  } catch (error) {
  }
}
export function* resetSettlementData(action: any) {
  yield put({ type: SETTLEMENT_RESET_DATA });
}

export function* settlementSaga() {
  yield takeLatest(SETTLEMENT_RESET_STATE, resetSettlementData);
  yield takeLatest(OVERVIEW_DATA_REQUEST, fetchOverviewCardData);
  yield takeLatest(SETTLEMENT_TINFILTER_DATA_REQUEST, fetchQuickFilterTinData);
  yield takeLatest(SETTLEMENT_PAYMENT_DATA_REQUEST, fetchSettlementPayment);
  yield takeLatest(SETTLEMENT_VOLUME_DATA_REQUEST, fetchSettlementVolumeData);
  yield takeLatest(SETTLEMENT_TREND_DATA_REQUEST, fetchSettlementTrendData);
  yield takeLatest(SETTLEMENT_TREND_MEDICAID_REQUEST, fetchSettlementMedicaidData);
  yield takeLatest(SETTLEMENT_TREND_MEDICARE_REQUEST, fetchSettlementMedicareData);
  yield takeLatest(SETTLEMENT_TREND_UNCATERGORIZED_REQUEST, fetchSettlementUncategorizedData);
  yield takeLatest(SETTLEMENT_TREND_COMMERCIAL_REQUEST, fetchSettlementCommericalData);

  yield takeLatest(SETTLEMENT_DETAILS_DATA_REQUEST, fetchSettlementDetailsData);
  yield takeLatest(SETTLEMENT_GEOFILTER_DATA_REQUEST, fetchGeoFilterData);
  // yield takeLatest(SETTLEMENT_TREND_DATA_REQUEST, fetchSettlementTrendData);
}